module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "information-container"
  }, [_c('div', {
    staticClass: "disclosure-information-wrapper"
  }, [(_vm.settingsData) ? _c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "placeholder": "Текст информации"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveDisclosureInformation()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), (_vm.documentsData) ? _c('draggable', {
    staticClass: "columns is-multiline documents",
    model: {
      value: (_vm.documentsData),
      callback: function($$v) {
        _vm.documentsData = $$v
      },
      expression: "documentsData"
    }
  }, _vm._l((_vm.documentsData), function(document) {
    return _c('DisclosureItem', {
      key: document.id,
      attrs: {
        "document": document
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered add-document"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": _vm.handleAddDisclosureInformation
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить информацию\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76adecdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/Disclosure.vue
// module id = 969
// module chunks = 0